// Map question text and survey question text should be translated within appConfig.js
// Do not edit text within curly brackets, ie: {abc}
// Format: "<ComponentName>.<Description>": "<Text>"

module.exports = ({
    "polyline": "Ruta",
    "icon": "Marcador",
    "polygon": "Forma",

    // (optional) {branch_name} can be used to display the branch display name in the document title
    "DocumentTitle.map_page": "{branch_name} | Mapa",
    "DocumentTitle.error_page": "{branch_name} | Error",
    "DocumentTitle.end_page": "{branch_name} | Finish",
    "DocumentTitle.intro_modal": "{branch_name} | Terminar",
    "DocumentTitle.info_modal": "{branch_name} | Informacion",
    "DocumentTitle.survey_modal": "{branch_name} | Encuesta",

    "Landing.header": "¡Bienvenidas!",
    "Landing.main_copy": "Use esta herramienta para decirnos cómo interactúa con su vecindario y ayudarnos a comprender las consideraciones para este lugar.",
    "Landing.back_to_map": "Volver al mapa",
    "Landing.start_answering": "Empezar",
    "Landing.data.header": "Uso de datos",
    "Landing.data.copy": "Protegeremos su privacidad y todos los datos se utilizarán solo internamente.",
    "Landing.help.header": "Instrucciones",
    "Landing.help.copy": "En el mapa puedes dibujar puntos, líneas o áreas para describir tu lugar. Puede buscar un lugar, y el mapa se puede desplazar, acercar y alejar, y alternar entre la hoja de ruta y el satélite.",
    "Landing.feedback": "Envianos tus comentarios",

    "MapContainer.continue": "Seguir",
    "MapContainer.back_button": "Volver al mapa",
    "MapContainer.info_button": "Instrucciones",
    "MapContainer.finish_button": "Terminado con el mapa",
    "MapContainer.submit": "Enviar",
    "MapContainer.mapButtonInfo": "Zoom a la ubicación",
    "MapContainer.roadmap": "Mapa vial",
    "MapContainer.satellite": "Satélite",

    "CancelButton.text": "Cancelar",

    "IconDrawer.expand_drawer": "Expandir",
    "IconDrawer.instructions": "Dibujar",

    "LayerToggle.roadmap": "Mapa vial",
    "LayerToggle.satellite": "Satélite",

    "ConfirmationPopup.done": "Hecho",
    "ConfirmationPopup.cancel": "Cancelar",

    "PolygonDraw.default_message": "Haga clic en cualquier lugar para comenzar a dibujar su forma.",
    "PolygonDraw.alternative_message": "Dibuja puntos para cambiar el tamaño de tu forma.",

    "PolylineDraw.default_message": "Haga clic en cualquier lugar para comenzar a dibujar su línea.",
    "PolylineDraw.alternative_message": "Dibuja puntos para cambiar el tamaño de tu línea.",

    "IconDrop.default_message": "Haga clic en cualquier lugar para agregar un icono.",
    "IconDrop.alternative_message": "Arrastre el icono para cambiar su posición.",

    "EditModal.delete": "Eliminar",
    "EditModal.save": "Salvar",
    "EditModal.cancel": "Cancelar",
    "EditModal.textarea_placeholder": "Cuéntanos más o haga clic en guardar.",
    "EditModal.addTitle": "Agrega tu {icon_type}",
    "EditModal.editTitle": "Edita tu {icon_type}",
    "EditModal.reactionTitle": "¿Tu experiencia aquí es buena o mala?",
    "EditModal.starRatingTitle": "¿Cómo calificaría su experiencia aquí?",
    "EditModal.commentTitle": "¿Alguna otra idea?",
    "EditModal.deleteConfirmation": "Are you sure?",
    "EditModal.deleteConfirmationText": "Removing this {icon_type} cannot be undone.",

    "SearchBox.placeholder": "Buscar ubicación",

    "Survey.submitting": "Sumisión...",

    "EndLanding.header": "Gracias",
    "EndLanding.copy": "Copia final",
    "EndLanding.take_again": "Comparta más información sobre su lugar. ¡Comience de nuevo!",
});



// WEBPACK FOOTER //
// ./src/locales/es-ES.js